<template>
  <div>
    <v-dialog
      v-model="comment_dialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card v-if="one_check" style="border-radius: 12px;">
        <v-card-title primary-title>
          {{ cannot_edit ? 'Editando Comentário' : 'Comentário'}}
        </v-card-title>
        <v-card-text class="pb-0">
          <v-col class="px-0 pt-3 pb-0">
            <v-textarea label="Comentário" v-model="one_check.comment" :readonly="!cannot_edit"></v-textarea>
          </v-col>
        </v-card-text>
        <v-card-actions class="justify-end">
          
          <f-btn v-if="one_check.status != 'concluded'" @click="$emit('closeComment')" cancel></f-btn>
          <f-btn v-if="one_check.status != 'concluded' && cannot_edit" @click="updateComment" save></f-btn>
          <f-btn v-if="one_check.status == 'concluded'" @click="$emit('closeComment')" close></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Api from '@/api/index';

export default {
  props: {
    comment_dialog: {
      type: Boolean,
      default: false
    },
    check: {
      type: Object
    },
    cannot_edit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      one_check: {}
    }
  },
  mounted () {
    ;
  },
  methods: {
    setupOneCheck() {
      this.one_check = {
        ...this.check
      }
    },
    updateComment(){
      const {id, comment} = this.one_check
      let obj = { id, comment }
      Api.ReturnedCheck.update(obj).then(r=>{
        // console.log('updated returned check', {r});
        this.$emit('doneUpdate', {...r.data})
        this.addNotification({type: 'success', msg: 'Comentário salvo com sucesso'})
      })
    },
    ...mapActions({
      
    })
  },
  watch: {
    comment_dialog(nv) {
      if(nv) {
        this.setupOneCheck()
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
